/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_JenrealityInputs */

const cs_enum_jenreality = /** @type {(inputs: Enum_JenrealityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JenReality`)
};

const en_enum_jenreality = /** @type {(inputs: Enum_JenrealityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JenReality`)
};

/**
* | output |
* | --- |
* | "JenReality" |
*
* @param {Enum_JenrealityInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_jenreality = /** @type {((inputs?: Enum_JenrealityInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_JenrealityInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_jenreality(inputs)
	return cs_enum_jenreality(inputs)
});